import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars
import { useState } from "preact/hooks";

import cx from "classnames";
import sanitizeHtml from "sanitize-html";

import SVGIcon from "../../../../app/components/SVGIcon";
import utils from "../../../../helpers/utils";
import { ISearchParams } from "../../App";

export interface ISearchBox {
  className?: string;
  query?: string;
  params: ISearchParams;
  inNav?: boolean;
  inStandalonePageBlock?: boolean;
  setNewQuery?: (params: any) => void;
  placeholder?: string;
  id: string;
}

const SearchBox: FunctionComponent<ISearchBox> = ({
  className,
  query,
  params,
  inNav,
  inStandalonePageBlock,
  setNewQuery,
  placeholder,
  id,
}) => {
  const [searchQuery, setSearchQuery] = useState<string | undefined>(query);
  const placeholderText = placeholder || "Search for site content &amp; literature";

  const newParamsString = (query?: string, queryTyped?: boolean): string => {
    const newParams = Object.assign(params, {
      query: query ? sanitizeHtml(query) : undefined,
      page: undefined,
      filters: undefined,
      selectedFilters: undefined,
      sort: undefined,
      sortBy: undefined,
      queryTyped,
    });
    return utils.serializeParams(newParams);
  };

  const setQuery = (e: any) => {
    // Override any new params here, i.e. the new query, clear filters, pagination, etc
    e.preventDefault();
    e.stopPropagation();
    setNewQuery(newParamsString(searchQuery, true));
  };

  // Clear search term, filters, pagination, etc.
  const resetQuery = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setSearchQuery("");
    // Only re-search on a page search & ignore if user cleared without searching (params.query only populates on a search)
    if (!inNav && params.query) {
      setNewQuery(newParamsString());
    }
  };

  return (
    <form
      className={cx(className, "search-box__container")}
      role="search"
      onSubmit={setQuery}
    >
      <fieldset className="search-box__fieldset">
        <legend className="visually-hidden">Search box</legend>
        <label
          className="visually-hidden"
          htmlFor={`SearchBox-${id}-${inNav && "-nav"}`}
        >
          Search
        </label>
        <input
          id={`SearchBox-${id}-${inNav && "-nav"}`}
          type="search"
          className="search-box__input input--search"
          placeholder={placeholderText}
          value={searchQuery}
          onInput={(e: any) => setSearchQuery(e.currentTarget.value)}
          autofocus={!inNav}
        />

        <button
          className="search-box__button
          search-box__button--search
          cta
          cta--outline-strong
          cta--with-icon
          cta--search"
          type="submit"
        >
          <SVGIcon
            className="button--icon icon search-icon search-box__button-icon"
            name="search"
          ></SVGIcon>

          <span className="button--with-icon-text search-link-text-toggled">Search</span>
        </button>

        {searchQuery && (
          <button
            className="search-box__button search-box__button--close button button--with-icon button--close"
            type="submit"
            onClick={resetQuery}
          >
            <SVGIcon
              name="close"
              spriteUrl="/Content/images/v3/svg-sprite.svg"
            ></SVGIcon>
          </button>
        )}
      </fieldset>

      {inNav && !inStandalonePageBlock && (
        <button className="search-box__close js-nav-search-close unbutton">Close</button>
      )}
    </form>
  );
};

export default SearchBox;
